import { Component } from '@angular/core';
import { UiPageWrapperComponent } from '@app/shared/ui/page-wrapper/ui-page-wrapper.component';

@Component({
  selector: 'proffeo-home',
  templateUrl: './home.component.html',
  imports: [UiPageWrapperComponent]
})
export class HomeComponent {}
